import React, { useEffect, useState } from 'react';
import { useRotationStore } from '../../../context/RotationContext';
import { ReportLocationEnum } from '../../../enums/reportLocationEnum';
import { RotationTreeEnum } from '../../../enums/rotationTreeEnum';
import { BerthCall } from '../../../types/ViewModel/BerthCall';
import { CargoOperation } from '../../../types/ViewModel/CargoOperation';
import { IRotationNode } from '../../../types/ViewModel/IRotationNode';
import { SelectedRotationsWrapper } from 'src/components/stowage/common/voyageSelectionPanel/VoyageSelectionPanel.styles';

const SelectedRotationInfo: React.FC = () => {
    const [, setReportingLocationText] = useState<string>('');
    const { selectedNode, updatedRotation, selectedStowageVoyages } = useRotationStore();

    const getParentBerthCallFromNode = (rotationNode: IRotationNode): BerthCall | null => {
        const cargo: CargoOperation = rotationNode as CargoOperation;
        return cargo.berthCall;
    };

    const getSelVoyLabel = (): string => {
        if (selectedStowageVoyages.length > 1) {
            return 'Selected voyages';
        }
        return 'Selected voyage';
    };

    useEffect(() => {
        let portText = '';

        if (selectedNode) {
            if (selectedNode.name && selectedNode.reportLocation === ReportLocationEnum.Sea) {
                portText = selectedNode.name;
                setReportingLocationText(portText);
            } else if (selectedNode.name && selectedNode.reportLocation === ReportLocationEnum.Port) {
                const portCall = updatedRotation?.portCallArray.find((pc) => pc.portCallId === selectedNode?.portCall?.portCallId);

                if (portCall) {
                    portText = portCall.name;
                }

                if (selectedNode.type === RotationTreeEnum.PortCall) {
                    setReportingLocationText(portText);
                } else if (selectedNode.type === RotationTreeEnum.BerthCall) {
                    if (portCall) {
                        const bc = portCall.berthCallArray.find((bc) => bc.berthCallId === selectedNode.id);
                        if (bc && bc?.name) {
                            setReportingLocationText(portText + ' <span class="separator">></span> ' + bc.name);
                        }
                    }
                } else if (selectedNode.type === RotationTreeEnum.CargoOperation) {
                    if (portCall) {
                        const bc = getParentBerthCallFromNode(selectedNode);
                        if (bc && bc?.name) {
                            setReportingLocationText(
                                portText + ' <span class="separator">></span> ' + bc.name + ' <span class="separator">></span> ' + selectedNode.name
                            );
                        }
                    }
                }
            }
        }
    }, [selectedNode]);

    return (
        <SelectedRotationsWrapper>
            {selectedStowageVoyages && selectedStowageVoyages.length > 0 && (
                <span className="info-text text-overflow">
                    {getSelVoyLabel()}{' '}
                    {selectedStowageVoyages.map((selectedRotation, index) => {
                        return (
                            <span className="selected-rotation-label" key={`rot-` + selectedRotation}>
                                {selectedRotation}
                                {selectedStowageVoyages.length > 1 && index !== selectedStowageVoyages.length - 1 && <span className="sep">,</span>}
                            </span>
                        );
                    })}
                </span>
            )}
        </SelectedRotationsWrapper>
    );
};

export default SelectedRotationInfo;
